var counter = 0;
export var createControlId = function () {
    return "ci" + ++counter;
};
